import React from "react";

import './css/internship.css'

export default function Internship(){
    return(
        <div className="internship">
            <h2>Internship</h2>
            <div className="internship-cards"><h2>Solution Writing</h2><p>Write Solution</p></div>
        </div>
    )
}